import {route} from '@/router/route-utils'

const prefix = '/admin/requests-archive';

const routes = [

    route(
        prefix, 'admin.requests.archive.list', {
            components : {
                main: () => import('./views/AdminRequestsListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Richieste',
            breadcrumb: [
                {text: 'Richieste', active: true},
            ],
        }
    ),

    route(
        prefix + '/:id', 'admin.requests.archive.details', {
            components : {
                main: () => import('./views/AdminRequestsDetailsView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Richieste',
            breadcrumb: [
                {text: 'Richieste', to: {name: 'admin.requests.archive.list'}},
                {text: 'richiesta', active: true},
            ],
        }
    )

];

export default routes
